import React from 'react';
import { Formik, Form } from 'formik';
import { ForgotPasswordSchema } from '../../../schemas';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import { FormikInput } from '../Formik';
import Button from '../Button';

const ForgotPasswordForm = ({ submitHandler }) => {
    const { content } = useContentfulContext();

    return (
        <Formik
            initialValues={{
                email: ''
            }}
            validationSchema={() => ForgotPasswordSchema(content.FORGOT_PASSWORD_CONTENT)}
            onSubmit={async (values, actions) => {
                submitHandler();
            }}
        >
            {() => (
                <Form className="space-y-4 md:space-y-6" action="#">
                    <FormikInput
                        type="email"
                        id="email"
                        name="email"
                        label={content.FORGOT_PASSWORD_CONTENT.formLabels.email}
                        placeholder="name@company.com"
                    />
                    <div>
                        <Button type="submit" variant="primary" className="w-full">
                            Submit
                        </Button>
                    </div>
                    <div className="flex items-start">
                        <div className="text-sm">
                            <span className="font-light text-gray-500">{content.FORGOT_PASSWORD_CONTENT.instruction_text.privacy_policy_text}</span>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default ForgotPasswordForm;
